import React, { useEffect, useState } from 'react';
import Header from '../../components/common/global-top-bar';
import Spinner from '../../components/common/spinner';
import Searchbar from '../../components/common/searchbar';
import { ToggleButton } from '../../components/common';
import EditResourceDetails from './resource-edit';
import { Resource, useResources } from '../../hooks/useResources';
import { normalizeMobilePhone } from '../../components/common/phone-validation';
import { useFomTagGroups } from '../../hooks/useTagGroups';
import { AreaLabel } from '../../components/ui';

const ResourceListing: React.FC = () => {
  const [includeHidden, setIncludeHidden] = useState(false);
  const [search, setSearch] = useState<string>('');
  const { data: resources, isLoading, refetch } = useResources(includeHidden, search);
  const { getById } = useFomTagGroups();

  useEffect(() => {
    refetch();
  }, [search]);

  return (
    <div>
      <Header heading={'Resources'} />
      <FiltersNew
        resources={resources}
        setSearch={setSearch}
        includeHidden={includeHidden}
        setIncludeHidden={setIncludeHidden}
      />
      {isLoading && <Spinner />}
      <div className="max-window-height-table overflow-y-auto border-b px-7">
        <table className="table-row-format relative w-full table-fixed border-collapse">
          <thead className="sticky top-0 bg-white">
            <tr className="px-7 text-left">
              <th className="w-2/12" />
              <th className="w-2/12" />
              <th className="w-4/12">Name</th>
              <th className="w-4/12">Areas</th>
              <th className="w-3/12">Phone</th>
              <th className="w-3/12">URL</th>
            </tr>
          </thead>
          <tbody>
            <tr className="h-2"></tr>
            {resources?.length ? (
              resources?.map((resource: Resource) => {
                return (
                  <>
                    <tr className="text-gray-dark border-t-8 border-white bg-gray-200 text-left">
                      <td className="w-2/12 px-5 pt-5">
                        <EditResourceDetails resource={resource} />
                      </td>
                      <td className="w-2/12 pb-2 pt-5">
                        {resource?.image_url ? (
                          <img width="60" src={resource?.image_url} alt="Resource Image" />
                        ) : (
                          <div className="w-24" />
                        )}
                      </td>
                      <td className="w-4/12 pt-5">
                        <div className="text-gray-dark truncate font-extrabold">{resource?.name}</div>
                      </td>
                      <td className="flex w-5/12 flex-col gap-y-2 pt-5">
                        {resource?.challenge_areas?.map((id) => {
                          // @ts-ignore
                          return <AreaLabel className="flex-nowrap" key={id} variant={getById(id)?.name} />;
                        })}
                      </td>
                      <td className="w-3/12 pt-5">{normalizeMobilePhone(resource?.phone_number?.replace('+1', ''))}</td>
                      <td className="w-3/12 pl-1 pt-5">
                        <div className="truncate">{resource?.url}</div>
                      </td>
                    </tr>
                    <tr className="text-gray-dark group h-6 bg-gray-200 text-left">
                      <td />
                      <td colSpan={2}>
                        <div className="max-w-2xl truncate pb-2">{resource?.description}</div>
                      </td>
                      <td colSpan={1} />
                      <td colSpan={2}>
                        <div className="max-w-2xl truncate pb-2">{resource?.long_description}</div>
                      </td>
                    </tr>
                  </>
                );
              })
            ) : (
              <tr>
                <td colSpan={5}>
                  <div className="flex items-center justify-center">
                    <p className="text-gray-dark text-2xl">No Resources Found</p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const FiltersNew: React.FC<{
  resources?: Resource[];
  setSearch: React.Dispatch<React.SetStateAction<string>>;
  includeHidden: boolean;
  setIncludeHidden: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ resources, includeHidden, setIncludeHidden, setSearch }) => {
  const newResource = {
    name: '',
    description: '',
    phone_number: '',
    url: '',
    url_description: '',
    image_url: '',
    sort_weight: 0,
    status: 'live',
    text_number: '',
    notes: '',
    long_description: '',
    meta_keywords: '',
    challenge_areas: [],
    subject_areas: [],
  };

  return (
    <div className="gray-border-line bg-gray-background-light flex w-full items-center justify-between border-b px-7">
      <div className="flex h-8 w-1/4 items-center">
        <Searchbar search={(data) => setSearch(data)} />
      </div>
      {resources?.length && (
        <div className="flex w-1/5 items-center py-4 text-center text-sm">
          <p>
            Displaying 1-{resources.length} of {resources.length} matching
          </p>
        </div>
      )}
      <div className="flex w-1/4 items-center py-4">
        <span className="px-3 text-sm">Only Hidden</span>
        <ToggleButton
          id={'includeHidden'}
          status={includeHidden}
          initialstatus={false}
          setStatus={(data: boolean) => {
            data ? setIncludeHidden(true) : setIncludeHidden(false);
          }}
        />
      </div>
      <div className="my-auto">
        <EditResourceDetails resource={newResource} />
      </div>
    </div>
  );
};

export default ResourceListing;
